import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { DepartmentFunding, formatCurrency } from '../utils/executiveMetrics';
type DepartmentFundingChartProps = {
  data: DepartmentFunding[];
};
export function DepartmentFundingChart({
  data
}: DepartmentFundingChartProps) {
  const total = data.reduce((sum, d) => sum + d.totalFunding, 0);
  const CustomTooltip = ({
    active,
    payload
  }: any) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload as DepartmentFunding;
      const percentage = (item.totalFunding / total * 100).toFixed(1);
      return <div className="bg-white px-4 py-3 shadow-lg rounded-lg border border-gray-200" data-id="element-1">
          <p className="font-semibold text-gray-900" data-id="element-2">{item.department}</p>
          <p className="text-gray-600 text-sm" data-id="element-3">
            {formatCurrency(item.totalFunding)} ({percentage}%)
          </p>
          <p className="text-gray-500 text-xs mt-1" data-id="element-4">
            {item.employeeCount} employees
          </p>
        </div>;
    }
    return null;
  };
  const renderLegend = (props: any) => {
    const {
      payload
    } = props;
    return <div className="flex flex-wrap justify-center gap-4 mt-4" data-id="element-5">
        {payload.map((entry: any, index: number) => <div key={index} className="flex items-center gap-2" data-id="element-6">
            <div className="w-3 h-3 rounded-full" style={{
          backgroundColor: entry.color
        }} data-id="element-7" />
            <span className="text-sm text-gray-600" data-id="element-8">{entry.value}</span>
          </div>)}
      </div>;
  };
  return <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 h-full" data-id="element-9">
      <div className="mb-6" data-id="element-10">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-11">
          Funding by Department
        </h3>
        <p className="text-sm text-gray-500 mt-1" data-id="element-12">
          Total: {formatCurrency(total)} across {data.length} departments
        </p>
      </div>

      <div className="h-[300px] relative" data-id="element-13">
        <ResponsiveContainer width="100%" height="100%" data-id="element-14">
          <PieChart data-id="element-15">
            <Pie data={data} cx="50%" cy="50%" innerRadius={70} outerRadius={110} paddingAngle={2} dataKey="totalFunding" nameKey="department" data-id="element-16">
              {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-17" />)}
            </Pie>
            <Tooltip content={<CustomTooltip data-id="element-19" />} data-id="element-18" />
            <Legend content={renderLegend} data-id="element-20" />
          </PieChart>
        </ResponsiveContainer>

        {/* Center label overlay */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none" style={{
        marginBottom: '60px'
      }} data-id="element-21">
          <div className="text-center" data-id="element-22">
            <p className="text-2xl font-bold text-gray-900" data-id="element-23">
              {formatCurrency(total)}
            </p>
            <p className="text-xs text-gray-500" data-id="element-24">Total Funded</p>
          </div>
        </div>
      </div>
    </div>;
}